import { createAsyncThunk } from "@reduxjs/toolkit";
import { firebaseRemoveUserFromGroupAPI, getAllFirebaseGroupAPI } from "../../routes/apiEndPoints";
import { API_REQUEST } from ".";



export const fetchAllGroups = createAsyncThunk("Get-all-groups",async () => {
    try {
      const response = await API_REQUEST({ 
        url: getAllFirebaseGroupAPI,
        method: "GET",
      })
      return response.data;      
    } catch (error) {}
  });


  //  firebase-RemoveUser-From-Group
export const firebaseRemoveUserFromGroup = createAsyncThunk(
  "firebase-RemoveUser-From-Group",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: firebaseRemoveUserFromGroupAPI,
        method: "Post",
        data: payload,
      });
      callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
}
);
  
  //filter-group
// export const filterGroup = createAsyncThunk("filter-Groupt", async (props) => {
//     const {payload} = props
//     const { type, search} = payload;
//     const params = {};
//     if (type) params.type = type;
//     if (search) params.search = search;
//     try {
//       const response = await API_REQUEST({
//         url: "",
//         method: "GET",
//         params: params,
//       });
//       return response;
//     } catch (error) {}
//   });